'use client';

import { EMarketingSpot } from '@/components/content/EMarketingSpot';
import { ContactBoxIcons } from '@/components/content/Footer/parts/UpperFooterSection/ContactBoxIcons';
import { newsletterGridTitleSubtitleStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/newsletterGridTitleSubtitleStyles';
import { newsletterTitleTypographyStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/newsletterTitleTypographyStyles';
import { sloganContactBoxIconsGridContainerStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/sloganContactBoxIconsGridContainerStyles';
import { sloganContactBoxIconsGridStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/sloganContactBoxIconsGridStyles';
import { tycBoxStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/tycBoxStyles';
import { tycLinkStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/tycLinktyles';
import { tycTypographyStylesSx } from '@/components/content/Footer/parts/UpperFooterSection/styles/tycTypographyStyles';
import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { JsonEspotResponseType } from '@/data/utils/dataMapContent';
import { Box, Grid, Link, Typography } from '@mui/material';

export const UpperFooterSection = ({ emsName }: { emsName: string }) => {
	const { jsonEspotData } = useContentRecommendation(emsName, true);
	const data = jsonEspotData as JsonEspotResponseType;

	return (
		<>
			<Box sx={tycBoxStylesSx}>
				<Link
					rel="noreferrer"
					href={data && data?.tyc && data?.tyc[0]?.url}
					target={'_blank'}
					sx={tycLinkStylesSx}
				>
					<Typography variant={'bodyBaseline'} sx={tycTypographyStylesSx}>
						{data && data?.tyc ? data?.tyc[0]?.text : null}
					</Typography>
				</Link>
			</Box>

			<Grid
				container
				sx={{
					backgroundColor: '#fff',
					boxShadow: '0 1px 4px 2px rgba(0,0,0,.05),0 2px 1px 0 rgba(0,0,0,.03)',
					margin: '10px 0 20px 0',
				}}
			>
				<Grid container>
					<Grid item sm={12} md={6} sx={newsletterGridTitleSubtitleStylesSx}>
						<Typography variant={'headingSubtitle'} sx={newsletterTitleTypographyStylesSx}>
							{data ? data?.newsletter?.title : null}
						</Typography>
						<Typography variant={'bodyBaseline'}>
							{data ? data?.newsletter?.subtitle : null}
						</Typography>
					</Grid>

					<Grid item xs={12} md={6}>
						<EMarketingSpot
							id={'MainFooter_NewsletterSection'}
							properties={{ emsName: 'MainFooter_NewsletterSection' }}
						/>
					</Grid>
				</Grid>
				<Grid sx={sloganContactBoxIconsGridContainerStylesSx}>
					<Grid item md={4} sx={sloganContactBoxIconsGridStylesSx}>
						<Typography variant={'headingTitle'} component={'h4'} fontFamily='"Open Sans Light"'>
							{data ? data?.slogan : null}
						</Typography>
					</Grid>
					<ContactBoxIcons contacts={data?.contacts ?? []} />
				</Grid>
			</Grid>
		</>
	);
};
